const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/** Escapes text for safe interpolation into an HTML document string. */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (ch) => HTML_ESCAPES[ch]);
}

/** True only for http(s) and blob URLs — blocks `javascript:` / `data:` etc. */
export function isSafeOpenUrl(url: string): boolean {
  try {
    const { protocol } = new URL(url, 'http://localhost');
    return ['http:', 'https:', 'blob:'].includes(protocol);
  } catch {
    return false;
  }
}
